import styled from "styled-components";

const Container = styled.div`
  max-width: 960px;
  margin: auto;
  padding: 0 16px;
`;

export default Container;



// WEBPACK FOOTER //
// ./src/UI/Layout/Container.js